var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("© Copyright 2016-2021 www.100doc.com.cn All right reserved.")])
}
var staticRenderFns = []

export { render, staticRenderFns }